<ng-container *transloco="let t;">
    <div class="container-fluid p-0">
        <div class="row p-0">
        <div class="col-12 col-lg-6 col-md-12 p-2 bulkUpload-rightColumn-border border-end">
            <div class="background-wrapper file-drop-zone" (fileDropped)="onFileDropped($event)" appDropFiles>
                <input class="fileDrop" type="file" multiple (change)="onFileDropped($event)"
                       [accept]="acceptableFiles"/>
                <div class="upload-icon-img ">
                    <img src="../../../../assets/images/icons/uploadIcon-files.png" alt="upload files">
                </div>
                <span class="font-weight-500">{{ t('Upload PDF files or drag and drop text (upload file modal) - Upload files or drag and drop') }}</span>
                <span class="csv-file-supported-text">
                    @if(section === 'document'){
                        {{t('Document supported files explanation (upload file modal) - Only file types are supported', {fileTypes: '.pdf, .docx, .doc, .xls, .xlsx, .jpg, .jpeg, .png'})}}
                    } @else {
                        {{t('Supported files explanation (upload file modal) - Only PDF (.pdf) file type is supported')}}
                    }
                </span>
            </div>
        </div>


        <div class="col-12 col-lg-6 col-md-12 pt-2 pb-2 ps-2 pe-0 dropped-files-list">
              <div class="uploaded-files-area">
                    <form [formGroup]="form">
                        <div formArrayName="files">
                            @for (file of formFiles?.controls; track file.value; let i = $index) {
                                <app-upload-file
                                        [ngClass]="{'invalid': file.invalid, 'file-size': file?.get('file')?.hasError('maxSize')}"
                                        [formGroupName]="i"
                                        class="mb-1"
                                        [file]="file.value.file"
                                        [documentTypes]="(documentTypes$ | async) | documentTypeSelectorFor: section"
                                        [categories]="categories$ | async"
                                        [progress]="file.value?.progress || 0 "
                                        [ngbTooltip]=" file | fileValidationTooltipText"
                                        (delete)="onFileDelete(i)"></app-upload-file>
                            } @empty () {
                                <div class="d-flex justify-content-center p-2">
                                    {{ t('Choose files notification (upload file modal) - Choose files to upload by dropping them on the left side or by using file browser') }}
                                </div>
                            }
                        </div>
                    </form>
                </div>
        </div>
    </div>
    </div>
</ng-container>
